export default (element) => {
  const initSwiper = () => {
    const swiper = element.querySelector('swiper-container');

    const prevBtn = element.querySelector('[data-swiper-prev]');
    const nextBtn = element.querySelector('[data-swiper-next]');
    const swiperOptions = {
      slidesPerView: 'auto',
      centeredSlides: false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      loop: false,
      spaceBetween: 10,
      freeMode: true,
      breakpoints: {
        768: {
          spaceBetween: 30,
          slidesPerGroup: 2,
          slidesPerGroupAuto: true,
        },
      },
      injectStyles: [
        `@media (max-width: 767px) {
         .swiper {
           overflow: visible !important;
          }
        }
      `,
      ],
      on: {
        afterInit: () => {
          nextBtn.setAttribute('aria-controls', swiper.id);
          prevBtn.setAttribute('aria-controls', swiper.id);
        },
      },
    };
    Object.assign(swiper, swiperOptions);
    swiper.initialize();
  };

  initSwiper();
};
